import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitch = ({ isMobile = false }) => {
  const { i18n } = useTranslation();
  const changeLanguage = async (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <button
      onClick={() => changeLanguage(i18n.language === "vi" ? "en" : "vi")}
      className={`
        flex items-center gap-1
        border border-border bg-card
        ${isMobile ? "text-xs px-2 py-1 mr-1" : "text-sm px-3 py-1"}
        rounded font-bold text-primary
        hover:bg-primary hover:text-white
        transition
      `}
      aria-label="Switch Language"
    >
      {i18n.language === "vi" ? <>🇺🇸 EN</> : <>🇻🇳 VI</>}
    </button>
  );
};

export default LanguageSwitch;
